import React, { Component } from "react";
import { Button, Card, notification, Row, Col, Form, Icon, Popover, Tooltip } from "antd";
import { FormUtils as GetAllFormFields } from 'sz-react-utils';
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import Request, { API_URL } from "../../../request";
import { HiInformationCircle } from "react-icons/hi";

const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

@Form.create()
class PayrollSettings extends Component {
    state = {
        trackUserAttendence: true,
        deductSalaryWorkFromHome: false,
        deductSalaryLeaveWithoutNotice: false,
        sandwichAllowedPerYear: false,
        deductEpfEsic: false,
        companySettingObject: {}
    };

    async componentDidMount() {
        let res = await Request.getBusinessDetails(activeUser.businessId);
        if (res) {
            this.props.form.setFieldsValue(res);
            this.setState({
                companySettingObject: res,
                trackUserAttendence: res.trackAllUserAttendence || false,
                deductSalaryWorkFromHome: res.deductSalaryWorkFromHome || false,
                deductSalaryLeaveWithoutNotice: res.deductSalaryLeaveWithoutNotice || false,
                sandwichAllowedPerYear: res.sandwichAllowedPerYear || false,
                deductEpfEsic: res.deductEpfEsic || false
            });
        }
    }

    onPrev = () => {
        this.props.onPrev();
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const that = this;
        this.props.form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                const values = _.clone(valData);
                values.businessId = activeUser.businessId;

                let response = await Request.addUpdateCompanySetting(values);
                if (response && response.success) {
                    notification.success({ message: "Payroll Settings Updated Successfully" });
                    if (that.props.onNext && this.props.isModal) that.props.onNext();
                } else {
                    notification.error({
                        message: "Error Saving",
                        description: response && response.message ? response.message : "Something went wrong"
                    });
                }
            }
        });
    };

    render() {
        const that = this;
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;
        const { loading, isModal } = this.props;
        const { trackUserAttendence, deductSalaryWorkFromHome, deductSalaryLeaveWithoutNotice, sandwichAllowedPerYear, deductEpfEsic } = this.state;

        // ✅ Tooltip Helper Function
        const withTooltip = (label, message) => (
            <span>
                {label}
                <Tooltip title={message}>
                    <Icon type="question-circle" style={{ marginLeft: 6, color: '#1890ff', cursor: 'pointer' }} />
                </Tooltip>
            </span>
        );

        const infoContent = (
            <div>
                <h4>Payroll & Attendance Help</h4>
                <p>Configure how your system handles staff presence and salary deductions.</p>
            </div>
        );

        const combinedInputSchema = {
            fields: [
                // ATTENDANCE SECTION
                {
                    label: withTooltip('Track all your User\'s Attendance?', 'Enables the Tvision tracking system to monitor staff log-in/out times.'),
                    key: 'trackAllUserAttendence',
                    type: 'switch',
                    onChange: v => { setFieldsValue({ trackAllUserAttendence: v }); that.setState({ trackUserAttendence: v }) }
                },
                {
                    label: withTooltip('Auto-Logout from CRM when Shift-Ends?', 'Automatically logs out the user and stops the timer once their shift hours are completed.'),
                    key: 'autoLogoutCrm',
                    type: 'switch',
                    onChange: v => setFieldsValue({ autoLogoutCrm: v })
                },
                {
                    label: withTooltip('Standard Working Hours', 'Define the expected daily work hours (e.g., 8 or 9).'),
                    type: 'number',
                    key: 'standardWorkingHours'
                },
                {
                    label: withTooltip('Paid Leaves Per Month?', 'Number of monthly leaves allowed without salary deduction.'),
                    type: 'number',
                    key: 'paidLeavesPerMonth'
                },
                {
                    label: withTooltip('Remind user before Shift Ends?', 'Sends a notification to the user shortly before their shift is scheduled to end.'),
                    key: 'remindBeforeShiftEnd',
                    type: 'switch',
                    hidden: !trackUserAttendence,
                    onChange: v => setFieldsValue({ remindBeforeShiftEnd: v })
                },
                {
                    label: withTooltip('Do you have Head of Departments?', 'Enable this if you have a reporting hierarchy. Leave requests will go to HODs instead of Admin directly.'),
                    key: 'haveHeadOfDepartments',
                    type: 'switch',
                    onChange: v => setFieldsValue({ haveHeadOfDepartments: v })
                },
                {
                    label: withTooltip('Sandwich leaves allowed per year?', 'A sandwich leave is when a holiday falls between two leave days. Define if this is allowed.'),
                    key: 'sandwichAllowedPerYear',
                    type: 'switch',
                    onChange: v => { setFieldsValue({ sandwichAllowedPerYear: v }); that.setState({ sandwichAllowedPerYear: v }) }
                },
                {
                    label: withTooltip('Number of sandwich leaves', 'Set the maximum limit for sandwich leaves per year.'),
                    key: 'numberOfSandwichLeaves',
                    type: 'number',
                    hidden: !sandwichAllowedPerYear,
                    required: sandwichAllowedPerYear
                },

                // SALARY SECTION
                {
                    label: withTooltip('Deduct salary for Work From Home?', 'Enable if you want to apply a specific percentage deduction for WFH days.'),
                    key: 'deductSalaryWorkFromHome',
                    type: 'switch',
                    onChange: v => { setFieldsValue({ deductSalaryWorkFromHome: v }); that.setState({ deductSalaryWorkFromHome: v }) }
                },
                {
                    label: withTooltip('WFH Deduction Amount (%)', 'The percentage of daily salary to be deducted for WFH.'),
                    key: 'amountInPercentageForWorkFromHome',
                    type: 'number',
                    hidden: !deductSalaryWorkFromHome,
                    required: deductSalaryWorkFromHome
                },
                {
                    label: withTooltip('Deduct salary for Leave Without Notice?', 'Enable if staff should be penalized for taking unannounced leaves.'),
                    key: 'deductSalaryLeaveWithoutNotice',
                    type: 'switch',
                    onChange: v => { setFieldsValue({ deductSalaryLeaveWithoutNotice: v }); that.setState({ deductSalaryLeaveWithoutNotice: v }) }
                },
                {
                    label: withTooltip('Leave Deduction Amount (%)', 'Percentage deduction for leaves taken without prior notification.'),
                    key: 'amountInPercentageForLeaveWithoutNotice',
                    type: 'number',
                    hidden: !deductSalaryLeaveWithoutNotice,
                    required: deductSalaryLeaveWithoutNotice
                },
                {
                    label: withTooltip('Providing EPF & ESIC Service?', 'Enable to calculate Provident Fund and Employee State Insurance deductions.'),
                    key: 'deductEpfEsic',
                    type: 'switch',
                    onChange: v => { setFieldsValue({ deductEpfEsic: v }); that.setState({ deductEpfEsic: v }) }
                },
                {
                    label: withTooltip('Max Salary Amount EPF', 'The ceiling limit of salary for EPF calculation.'),
                    key: 'maxSalaryForEPF',
                    type: 'number',
                    hidden: !deductEpfEsic,
                    required: deductEpfEsic
                },
                {
                    label: withTooltip('Max Salary Amount ESIC', 'The ceiling limit of salary for ESIC calculation.'),
                    key: 'maxSalaryForESIC',
                    type: 'number',
                    hidden: !deductEpfEsic,
                    required: deductEpfEsic
                },
                {
                    label: withTooltip('EPF Percentage', 'Employee\'s contribution percentage for EPF (usually 12%).'),
                    key: 'epfPercentage',
                    type: 'number',
                    hidden: !deductEpfEsic,
                    required: deductEpfEsic
                },
                {
                    label: withTooltip('ESIC Percentage', 'Employee\'s contribution percentage for ESIC.'),
                    key: 'esicPercentage',
                    type: 'text',
                    hidden: !deductEpfEsic,
                    required: deductEpfEsic,
                    prefixComp: 'Decimal'
                },
            ]
        };

        return (
            <div style={{ padding: '20px' }}>
                <Form onSubmit={this.handleSubmit}>
                    <Card bordered={true} style={{ borderRadius: '8px' }}>
                        <GetAllFormFields
                            apiurl={API_URL}
                            inputSchema={combinedInputSchema}
                            getFieldDecorator={getFieldDecorator}
                        />
                        <div style={{ marginTop: 30, textAlign: 'right', borderTop: '1px solid #f0f0f0', paddingTop: '20px' }}>
                            {this.props.onPrev && <Button onClick={this.onPrev} style={{ height: 40, width: 100, marginRight: 10 }}>BACK</Button>}
                            <Button type="primary" htmlType="submit" loading={loading} style={{ height: 40, width: 140 }}>{isModal ? <span>NEXT STEP <Icon type="arrow-right" /></span> : 'SAVE'}</Button>
                            {/* <Button type="primary" htmlType="submit" loading={loading} style={{ height: 40, width: 150, fontWeight: 600 }}>
                                NEXT STEP <Icon type="check" />
                            </Button> */}
                        </div>
                    </Card>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = ({ global }) => ({ loading: global.buttonLoading });
export default connect(mapStateToProps)(PayrollSettings);